import React from 'react';
import Track from './Track';
import { Link } from 'react-router-dom';

const TrackedLink = ({ ...props }) => {
    return <Track innerAs={Link} {...props} />;
};

export default TrackedLink;
